// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1kh0s";
var _4 = "title-2IBhr";
var _5 = "text-3uUxD";
var _6 = "row-3CLM5";
var _7 = "input_wrapper-wR4wd";
var _8 = "button_wrapper-2wxuz";
var _9 = "social_wrapper-3wrss";
var _a = "social_title-2F1s5";
var _b = "button_continue-3YJWr";
var _c = "switch_elements-2yxLJ";
var _d = "switch__label-ytqhW";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "title", _5 as "text", _6 as "row", _7 as "input_wrapper", _8 as "button_wrapper", _9 as "social_wrapper", _a as "social_title", _b as "button_continue", _c as "switch_elements", _d as "switch__label" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "title": _4, "text": _5, "row": _6, "input_wrapper": _7, "button_wrapper": _8, "social_wrapper": _9, "social_title": _a, "button_continue": _b, "switch_elements": _c, "switch__label": _d }
